export default "__VITE_ASSET__CfYVuZAm__"